/**
 * Feedback tátil leve para ações importantes (check-in, missão, favorito).
 * Usa a Vibration API quando disponível. No-op em desktops e iPhones que não
 * suportam (a maioria dos navegadores iOS ignora `navigator.vibrate`).
 *
 * Respeita `prefers-reduced-motion` para não incomodar quem desativou
 * efeitos sensoriais.
 */

export type HapticPattern = 'light' | 'medium' | 'heavy' | 'success' | 'error';

const PATTERNS: Record<HapticPattern, number | number[]> = {
  light: 8,
  medium: 14,
  heavy: 22,
  success: [10, 30, 14],
  error: [20, 40, 20, 40, 20],
};

let prefersReducedMotion = false;

if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  prefersReducedMotion = mq.matches;
  mq.addEventListener?.('change', (e) => {
    prefersReducedMotion = e.matches;
  });
}

export function haptic(pattern: HapticPattern = 'light'): void {
  if (prefersReducedMotion) return;
  if (typeof navigator === 'undefined') return;
  if (typeof navigator.vibrate !== 'function') return;
  try {
    navigator.vibrate(PATTERNS[pattern]);
  } catch {
    // Alguns dispositivos lançam erro se vibration estiver bloqueada por política — ignora.
  }
}
